module.exports = __webpack_public_path__ + "media/video-loop-phone.8e33bfac.mp4";